export default __webpack_public_path__ + "../staticImages/kaese-260.png";